/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ExportVisualState {
    Default = 0,
    Terminated = 1,
    Dismissed = 2,
}
